var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v(" Download yearly Excel reports for auction data. ")]), _c('a-list', {
    attrs: {
      "data-source": _vm.years,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(year) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('template', {
          slot: "title"
        }, [_c('a-icon', {
          staticStyle: {
            "color": "#217346",
            "margin-right": "8px"
          },
          attrs: {
            "type": "file-excel"
          }
        }), _vm._v(" Auction Report " + _vm._s(year) + " ")], 1), _c('template', {
          slot: "description"
        }, [_vm._v(" Excel report for the year " + _vm._s(year) + " ")])], 2), _c('a-button', {
          attrs: {
            "type": "primary",
            "icon": "download",
            "loading": _vm.downloadingYear === year
          },
          on: {
            "click": function click($event) {
              return _vm.downloadExcelReport(year);
            }
          }
        }, [_vm._v(" Download ")])], 1);
      }
    }])
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Excel Reports")])])]);
}]

export { render, staticRenderFns }